import './data-table-container.css';
import CallToActionButton from '../call-to-action-button/call-to-action-button';
import ExportButton from '../export-button/export-button';
import Expandable from '../expandable/expandable';
import SortDropDownList from '../sort-drop-down-list/sort-drop-down-list';
import ClearIcon from '../../assets/icons/clear-icon.svg';
import DataTable, { CelType, Table } from '../data-table/data-table';
import React, { useMemo, useState } from 'react';
import SortDropDownListContent from '../sort-drop-down-list-content/sort-drop-down-list-content';
import generateAndDownloadExcelFile from '../excel/generate-and-download-excel-file';
import CancelButton from '../ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../ui/buttons/approve-button/approve-buttons';

interface DataTableContainerDatamodel {
  title: string;
  isLoading: boolean;
  lazyLoading: {
    columnNumber: number;
    rowsNumber: number;
  };
  table: Table;
  onRowSelected?: (index: number, id?: number) => void;
  onAddButtonClicked?: () => void;
  autoAddIndex?: boolean;
}

export function createTableDataRows(tableData: Table): string[][] {
  const arr: string[][] = [];
  tableData.rows.forEach((item) => {
    const nestedArr: string[] = [];
    item.cells.forEach((nestedItem) => nestedArr.push(nestedItem.content));
    arr.push(nestedArr);
  });
  return arr;
}

const DataTableContainer: React.FC<DataTableContainerDatamodel> = ({
  title,
  isLoading = true,
  lazyLoading,
  table,
  onRowSelected,
  onAddButtonClicked,
  autoAddIndex = true,
}) => {
  const [isInputActive, setIsInputActive] = useState(false);
  const [isSelectRowActive, setIsSelectRowActive] = useState(false);

  const onExportTableClick = async () => {
    await generateAndDownloadExcelFile(createTableDataRows(table));
  };

  const onAddButtonCall = () => {
    onAddButtonClicked && onAddButtonClicked();
    setIsInputActive(true);
  };

  const prepareDataForTableUI = useMemo(() => {
    const newRowHeader = {
      ...table.rowHeader,
      cells: [
        {
          content: 'מס״ד',
          type: CelType.REGULAR,
        },
        ...(table.rowHeader ? table.rowHeader.cells : []),
      ],
    };
    return {
      ...table,
      rowHeader: newRowHeader,
      rows: table.rows.map((row, rowIndex) => {
        return {
          ...row,
          cells: [
            {
              content: rowIndex + 1,
              type: isSelectRowActive ? CelType.CHECK_BOX : CelType.REGULAR,
            },
            ...row.cells,
          ],
        };
      }),
    };
  }, [table, autoAddIndex, isSelectRowActive]);

  return (
    <div className={'sort-root-column'}>
      <div className={'sort-root sort-row'}>
        <div className={'sort-row'}>
          <div className={'sort-title'}>{title}</div>

          {!isLoading && (
            <div className={'sort-title-counter'}>({table.rows.length})</div>
          )}
        </div>

        <div className={'sort-row'}>
          <ExportButton
            onClick={() => {
              onExportTableClick();
            }}
          />
          <div className={'sort-space'}></div>
          <CallToActionButton text={'הוספה'} onClick={onAddButtonCall} />
        </div>
      </div>
      <br />
      {/*<div className={'sort-row-regular-space-between'}>
        <div className={'sort-row-regular'}>
          {!!table.rows.length &&
            table.rows[0].cells.map((item, index) => {
              return (
                <Expandable
                  makeAbsolute={true}
                  displayChevron={false}
                  title={'Title'}
                  top={
                    <SortDropDownList
                      title={item.content}
                      content={'בחר הכל'}
                    />
                  }
                  bottom={
                    <SortDropDownListContent
                      checkbox={['a', 'b', 'c']}
                    ></SortDropDownListContent>
                  }
                ></Expandable>
              );
            })}
        </div>

        <div className={'sort-drop-down-list-root'}>
          <div className={'sort-clear-all-drop-down-list-box-title'}>מגמה</div>
          <div className={'sort-clear-all-drop-down-list-box'}>
            <img src={ClearIcon} />
            <div className={'sort-clear-all-drop-down-list-box-margin'}>
              נקה הכל
            </div>
          </div>
        </div>
      </div>*/}
      <br />

      <div style={{ paddingRight: 10, paddingLeft: 10, paddingBottom: 15 }}>
        <DataTable
          isAddActive={isInputActive}
          lazyLoading={lazyLoading}
          isLoading={isLoading}
          table={prepareDataForTableUI}
          onRowSelected={onRowSelected}
          autoAddIndex={autoAddIndex}
        />
      </div>

      {!isLoading && table && table.addRow && isInputActive && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            marginTop: '20px',
            paddingBottom: '10px',
          }}
        >
          <CancelButton
            onClick={() => {
              setIsInputActive(false);
            }}
          />

          <div style={{ width: '10px' }} />
          <ApproveButtons
            isLoading={table.addRow.isApproveLoading}
            onClick={async () => {
              await table.addRow.onSubmit();

              setIsInputActive(false);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DataTableContainer;
